
import Vue from 'vue';
import { Route } from 'vue-router/types/router';
import _findIndex from 'lodash/findIndex';

interface TabData {
	text: string
	route: Route // e.g. { name: ROUTER.COMPANY_DASHBOARD }
}

export default Vue.extend({
	name: 'PageTopNavigation',
	props: {
		tabsData: {
			type: Array as () => TabData[],
			required: true,
		},
	},
	data () {
		return {
			selectedTab: 0,
		};
	},
	watch: {
		'$route': {
			immediate: true,
			handler (newVal: Route, oldVal: Route) {
				if (newVal !== oldVal) {
					const setVal = (route: Route) => {
						let tabIndex: number = _findIndex(this.tabsData, (tab: TabData) => {
							// Try to find exact match first
							const routeData = this.$router.resolve(route);
							const tabRouteData = this.$router.resolve(tab.route);
							return routeData.href === tabRouteData.href;
						});
						if (tabIndex === -1) {
							tabIndex = _findIndex(this.tabsData, (tab: TabData) => {
								// Then try only on route name
								return tab.route.name && route.name === tab.route.name;
							});
						}
						if (tabIndex === -1) {
							tabIndex = 0;
						}
						this.selectedTab = tabIndex;
					};

					if (!this.selectedTab) {
						// delay, v-tabs has a hard time with initial value
						setTimeout(() => setVal(newVal), 100);
					} else {
						setVal(newVal);
					}
				}
			},
		},
	},
	methods: {
		navigate (route: Route) {
			this.routerPush(this.$route, this.$router, route);
		},
	},
});
